import { createContext } from 'react';
import { MultiMap } from "../../shared/collections";
import { PositionKey } from "./position";
import { UserData } from "./userdata";
import { GuideData, HomeData, TripData } from './interfaces';
import { BackgroundJob, BackgroundJobs } from './background-jobs';
import { FirebaseRefs } from './firebase';
import { AllTripActivities } from './placeFunctions';

export const UserContext = createContext<UserData>({
    isLoggedIn: false,
    status: 'unknown',
    countryTracking: undefined,
    searchProviders: undefined,
    privateDataLoaded: false,
});
export const HomeContext = createContext<HomeData>({
    uidPlaces: [],
    uidGuides: undefined,
    tripAdjacentUsersById: new Map(),
    userTrips: undefined,
    userTripsById: undefined,
});
export const AllTripActivitiesContext = createContext<AllTripActivities>({
    ideas: undefined,
    past: undefined,
    future: undefined,
    today: undefined,
    allActivities: new Map(),
    activityIdsByPlaceId: new MultiMap<string, string>(),
    activityIdsByNarrowAddress: new MultiMap<string, string>(),
    activityIdsByPositionKey: new MultiMap<PositionKey, string>(),
});
export const TripContext = createContext<TripData>({ currentTrip: undefined });
export const GuideContext = createContext<GuideData>({ currentGuide: undefined });
export const BackgroundJobContext = createContext<BackgroundJobs>({ jobs: [], registerJob: () => (<BackgroundJob>{}) });
export const FirebaseContext = createContext<FirebaseRefs | undefined>(undefined);
